import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { Link } from "react-router-dom";
import { getFincasAAFF } from '../../../services';
import { Box, Typography } from "@mui/material";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import Excel from "../../../icons/excel.svg";
import { diferenciaMesesCaducidad, estadoServicio, formatoFechasEs, ventaMasReciente, GRUPOS_SERVICIO } from "../../../functions/funciones";
import { UsuarioContext } from "../../../providers/userContext";
import { DataTable, NoVisitado } from '../../../components';
import FiltrosComunidadesTech from '../../../components/filtros/filtrosComunidadesTech';
import { useLocation, useNavigate } from "react-router-dom";
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';
import NoVisitadoAAFF from '../../../components/noVisitadoAAFF';




const ServicioCae = (props) => {
  const { t } = useTranslation(['properties', 'common']);
  const user = useContext(UsuarioContext);
  const [isLoading, setIsLoading] = useState(true);
  const [recargar, setRecargar] = useState(0);
  const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });


  const navigate = useNavigate();
  const location = useLocation();

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  }

  // useEffect(() => {
  //   fetchData({ offset: 1, limit: limite, filtros: busqueda })
  //   //setPorcentaje(65)
  //   setRecargar(false);
  // }, [recargar, limite, busqueda]);

  const fetchData = async ({ offset, limit, filtros = busqueda, order, orderBy } = {}) => {
    setIsLoading(true);
    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order = order || filtroOrder.orden || 'ASC';

    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy);

    if (props.aaff?.id) {
      const payload = {
        filtros: { ...filtros, aaff_id: props.aaff.id },
        params: { page: offset, limit, order, orderBy },
      };

      try {
        const response = await getFincasAAFF(payload);
        const { meta, data } = response;
        console.log(data)
        setData({
          meta,
          rows: formatData(data),
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const formatData = (data) => {
    const formattedData = []
    data.map((row) => {
      const sale_cae = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cae);
      const sale_cai = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cai);
      formattedData.push({
        id: row.id,
        finca: { ...row, properties: { nif: row.nif }, detailsCae: row.sales[0]?.detailsCae },
        aaff: row.aaff,
        sales: row.workcenters?.length > 0 ? [] : row.sales,
        razonSocial: row.razonSocial,
        nif: row.nif,
        createdAt: formatoFechasEs(row.createdAt),
        proveedores: sale_cae ? row.suppliers.filter(objeto => objeto.status === true).length : t('management.noHasSuppliers'),
        direccion: row.direccion,
        municipio: row.municipio,
        provincia: row.provincia,
        trabajadores: row.trabajadores === null ? false : row.trabajadores,
        codigoPostal: row.codigoPostal,
        isWorkcenter: false,
        // caducada: diferenciaMeses > 13 ? true : false,
        saleCae_id: sale_cae?.id || null,
        estadoCae: sale_cae ? sale_cae.estado_id === null ? 1 : sale_cae.estado_id : "-",
        saleCai_id: sale_cai?.id || null,
        estadoCai: sale_cai ? sale_cai.estado_id === null ? 1 : sale_cai.estado_id : "-",
        fechaUltVisita:

          row.workcenters.length === 0 && (row.visitada || row.renovadaVisitada) && row.visitSheets?.at(-1)?.createdAt ? (
            formatoFechasEs(row.visitSheets?.at(-1).createdAt)
          )
            :
            ((row?.sales?.[0]?.docsProps?.length === 0) || (row?.sales[0]?.docsProps?.[0]?.visitSheet_id == null && row?.sales?.[0]?.docsProps?.[0]?.ruta))?
              t('viewReport')
              :
              row.workcenters.length > 0 ? "" : (
                <p style={{ color: "red" }}>{t('visit.noVisit')}</p>
              )
      })
      if (row.workcenters?.length > 0) {
        row.workcenters?.forEach((wc) => {
          formattedData.push({
            id: wc.id,
            finca: wc,
            aaff: row.aaff,
            sales: wc.workSales,
            razonSocial: wc.razonSocial,
            nif: "",
            createdAt: wc.createdAt ? formatoFechasEs(wc.createdAt) : "",
            direccion: "",
            municipio: "",
            provincia: "",
            trabajadores: "",
            codigoPostal: "",
            isWorkcenter: true,
            estadoCae: "",
            estadoCai: "",
            saleCae_id: "",
            saleCai_id: "",
            fechaUltVisita: wc.visitSheets?.[wc.visitSheets.length - 1]?.createdAt ? (
              formatoFechasEs(wc.visitSheets?.[wc.visitSheets.length - 1]?.createdAt)
            ) :
              (
                <p style={{ color: "red" }}>{t('visit.noVisit')}</p>
              )
          });
        });
      }
    });
    return formattedData;
  };

  const comunidadesRows = [
    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.community'),
      overrideFunc: (data, row) => (
        <Link to={"/aaff/" + props.params.nif + "/comunidades/" + row.nif}>
          {data}
        </Link>
      )
    },
    {
      id: "nif",
      numeric: false,
      disablePadding: false,
      label: t('columns.nif'),
    },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: false,
      label: t('columns.createdAt'),

      overrideFunc: (data, row) => (

        <Typography style={{ textAlign: 'left' }}>
          {data}
        </Typography>

      ),
    },
    {
      id: "direccion",
      numeric: false,
      disablePadding: false,
      label: t('columns.address'),
    },
    {
      id: "codigoPostal",
      numeric: false,
      disablePadding: false,
      label: t('columns.postalCode'),
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('common:form.province').toUpperCase(),
    },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('columns.municipality'),
    },
    {
      id: "estadoCae",
      numeric: false,
      disablePadding: false,
      label: t('columns.caeStatus'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        !row.isWorkcenter ?
            <div className="activoSelect">
                <span style={{ color: data === 1 || data == null ? "#3eae3e" : data === 2 || data === 3 ? '#FF8300' : data === 4 || data === 5 ? "#EE4534" : "#000" }}>
                  {data === "-" ? data : estadoServicio(data, t)}
                </span>
            </div>
        : ""
      ),
    },
    {
      id: "estadoCai",
      numeric: false,
      disablePadding: false,
      label: t('columns.caiStatus'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        !row.isWorkcenter ?
            <div className="activoSelect">
                <span style={{ color: data === 1 || data == null ? "#3eae3e" : data === 2 || data === 3 ? '#FF8300' : data === 4 || data === 5 ? "#EE4534" : "#000" }}>
                  {data === "-" ? data : estadoServicio(data, t)}
                </span>
            </div>
        : ""
      ),
    },
    {
      id: "trabajadores",
      numeric: false,
      disablePadding: false,
      label: t('columns.employees'),
      overrideFunc: (data, row) => (        
        <Typography style={{ textAlign: 'left', extTransform: 'uppercase', padding: 0, fontSize: '11px', color: data ? "green" : 'red' }}>
        {data ? t('common:status.yes') : t('common:status.no')}
      </Typography>
      ),
    },
    {
      id: "fechaUltVisita",
      numeric: false,
      disablePadding: false,
      label: t('columns.lastVisitDate'),
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Typography style={{ textAlign: 'left' }}>
          {data}
        </Typography>
      )
    },
    {
      id: "noVisita",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: true,
      overrideFunc: (data, row) => (
        <Typography>
          {user.rol !== 'AAFF' ?
            // Sin marca del AAFF, el componente muestra el no visitado de la comunidad (fallback)
            row?.sales[0]?.detailsCae[0]?.visitSheet_id === null ?
              <NoVisitadoAAFF
                aaff={row?.aaff}
                nif={row?.aaff?.nif}
                servicio="CAE"
                fallback={
                  row?.sales[0]?.detailsCae[0]?.unRealized ?
                    row.isWorkcenter ?
                      <NoVisitado finca={row.finca} nif={row.id} tipo={"centroTrabajo"} />
                      :
                      <NoVisitado finca={row.finca} nif={row.nif} tipo={"finca"} />
                    : null
                }
              />
              : ''
            : ''}
        </Typography>
      ),
    }
  ];

  const filtrarDatos = (filtros) => {
    setBusquedaActiva(true)
    setBusqueda(filtros);
    // fetchData();
  };

  const [exportando, setExportando] = useState(false);

  const exportarExcel = async () => {
    if (exportando || !props.aaff?.id) return;
    setExportando(true);
    const toastId = toast.loading(t('common:excel.generatingExcel', { defaultValue: 'Generando Excel...' }));
    try {
      const resp = await getFincasAAFF({
        filtros: { ...busqueda, aaff_id: props.aaff.id },
        params: { page: 1, limit: 100000, order: filtroOrder.orden || 'ASC', orderBy: filtroOrder.ordenadoPor || 'id' },
      });
      const nombreEstado = (id) => (id === "-" ? "-" : estadoServicio(id, t));

      const categoriaVisita = (row) => {
        if (row.renovadaVisitada) return t('filters.renovatedVisited', { defaultValue: 'Renovada visitada' });
        if (row.renovada) return t('filters.renovatedPending', { defaultValue: 'Pendiente renovar' });
        if (row.visitada) return t('filters.visited', { defaultValue: 'Visitada' });
        return t('filters.pending', { defaultValue: 'Pendiente' });
      };
      const filas = [];
      (resp?.data || []).forEach((row) => {
        const saleCae = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cae);
        const saleCai = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cai);
        const estadoCae = saleCae ? (saleCae.estado_id ?? 1) : "-";
        const estadoCai = saleCai ? (saleCai.estado_id ?? 1) : "-";
        const ultimaVisita = (row.visitada || row.renovadaVisitada) && row.visitSheets?.at(-1)?.createdAt
          ? formatoFechasEs(row.visitSheets.at(-1).createdAt)
          : t('visit.noVisit');
        filas.push({
          AAFF: props.aaff?.razonSocial || "",
          Comunidad: row.razonSocial || "",
          NIF: row.nif || "",
          "Estado visita": categoriaVisita(row),
          "Fecha alta": row.createdAt ? formatoFechasEs(row.createdAt) : "",
          "Dirección": row.direccion || "",
          "Código Postal": row.codigoPostal || "",
          Provincia: row.provincia || "",
          Municipio: row.municipio || "",
          "Estado CAE": nombreEstado(estadoCae),
          "Estado CAI": nombreEstado(estadoCai),
          Trabajadores: row.trabajadores ? "Sí" : "No",
          "Última visita": ultimaVisita,
        });
      });

      if (filas.length === 0) {
        toast.update(toastId, { render: t('noCommunities'), type: "info", isLoading: false, autoClose: 3000 });
        return;
      }

      const ws = XLSX.utils.json_to_sheet(filas);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Comunidades");
      XLSX.writeFile(wb, `comunidades_${props.aaff?.nif || ""}_${Date.now()}.xlsx`);

      toast.update(toastId, { render: t('common:excel.excelSuccess', { defaultValue: 'Excel generado' }), type: "success", isLoading: false, autoClose: 3000 });
    } catch (error) {
      console.error("Error exportando Excel:", error);
      toast.update(toastId, { render: t('common:excel.excelError', { defaultValue: 'Error al generar el Excel' }), type: "error", isLoading: false, autoClose: 5000 });
    } finally {
      setExportando(false);
    }
  };

  return (
    <>
      <div className="pageContent tableContainer">
        <FiltrosComunidadesTech onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} />
        <div style={{ display: 'flex', justifyContent: 'flex-start', padding: '0 10px 10px' }}>
          <button
            className={`bigBtn ${exportando ? 'disabled' : ''}`}
            onClick={exportarExcel}
            disabled={exportando}
          >
            <img src={Excel} alt={t('common:technicians.generateList')} width="28px" />
            {exportando ? t('management.generatingList') : t('common:technicians.generateList')}
          </button>
        </div>
        <div className='tableWrapper'>
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={isLoading}
                headers={comunidadesRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('noCommunities')}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                enumerate={true}
                // propCaducada={true}
              />
            </Box>
          </Box>
        </div>
      </div>

    </>
  );
}

export default withRouter(ServicioCae);